const styles = {
	picker: {
		width: '100% !important',
		marginTop: '2rem'
	},
	addColor: {
		width: '100%',
		marginTop: '1rem',
		fontSize: '2rem'
	},
	colorNameInput: {
		width: '100%',
		height: '70px'
	}
};

export default styles;
